import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles(theme => ({
  root: {
    height: 57,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 29,
    padding: '5px 29px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    transition: theme.transitions.create(['boxShadow'], {
      easing: theme.transitions.easing.easeIn,
      duration: theme.transitions.duration.complex,
    }),
  },
  active: {
    boxShadow: '0 0 0 1pt grey',
  },
  textInput: {
    outline: 'none',
    border: 'none',
  },
  icon: {},
}));
